"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uom_1 = require("uom");
var uom_units_1 = require("uom-units");
var index_1 = require("./rp1485/index");
var saturationSafety = 0.999995;
function create(temperature, humidity, pressure, flow) {
    if (uom_1.Amount.lessThan(humidity, uom_1.Amount.create(0, uom_units_1.Units.GramPerKilogram))) {
        throw "Humidity must be a positive value";
    }
    if (uom_1.Amount.lessThan(pressure, uom_1.Amount.create(0, uom_units_1.Units.Pascal))) {
        throw "Pressure must be a positive value";
    }
    if (uom_1.Amount.lessThan(flow, uom_1.Amount.create(0, uom_units_1.Units.StandardCubicMeterPerHour))) {
        throw "Flow must be a positive value";
    }
    var dewPoint = index_1.AmountConversions.humidityRatioToDewPointTemperature(pressure, humidity);
    if (temperature <
        uom_1.Amount.create(uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, dewPoint), uom_units_1.Units.Celsius)) {
        throw new Error("Invalid humidity! T: " +
            uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature) +
            " x: " +
            uom_1.Amount.valueAs(uom_units_1.Units.GramPerKilogram, humidity) +
            " P: " +
            uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure) +
            " is below dewpoint " +
            uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, dewPoint) +
            "°C dp.");
    }
    var relHum = index_1.AmountConversions.humidityRatioToRelativeHumidity(pressure, temperature, humidity);
    return {
        temperature: temperature,
        humidity: humidity,
        pressure: pressure,
        flow: flow,
        relativeHumidity: relHum,
    };
}
exports.create = create;
function addTemperature(delta, airFlowState) {
    return setTemperature(uom_1.Amount.plus(airFlowState.temperature, delta), airFlowState);
}
exports.addTemperature = addTemperature;
function setTemperature(newTemperature, airFlowState) {
    if (uom_1.Amount.lessThan(newTemperature, index_1.AmountConversions.getSaturationTemperatureOfWater(airFlowState.pressure)) &&
        uom_1.Amount.lessThan(newTemperature, airFlowState.temperature)) {
        var saturated = index_1.AmountConversions.dewPointTemperatureToHumidityRatio(airFlowState.pressure, uom_1.Amount.create(saturationSafety * uom_1.Amount.valueAs(uom_units_1.Units.Kelvin, newTemperature), uom_units_1.Units.KelvinDewPoint));
        return create(newTemperature, uom_1.Amount.greaterThan(airFlowState.humidity, saturated)
            ? saturated
            : airFlowState.humidity, airFlowState.pressure, airFlowState.flow);
    }
    return create(newTemperature, airFlowState.humidity, airFlowState.pressure, airFlowState.flow);
}
exports.setTemperature = setTemperature;
function setHumidity(newHumidity, airFlowState) {
    if (uom_1.Amount.lessThan(airFlowState.temperature, index_1.AmountConversions.getSaturationTemperatureOfWater(airFlowState.pressure))) {
        var saturated = index_1.AmountConversions.dewPointTemperatureToHumidityRatio(airFlowState.pressure, uom_1.Amount.create(saturationSafety *
            uom_1.Amount.valueAs(uom_units_1.Units.Kelvin, airFlowState.temperature), uom_units_1.Units.KelvinDewPoint));
        return create(airFlowState.temperature, uom_1.Amount.greaterThan(newHumidity, saturated)
            ? saturated
            : airFlowState.humidity, airFlowState.pressure, airFlowState.flow);
    }
    return create(airFlowState.temperature, newHumidity, airFlowState.pressure, airFlowState.flow);
}
exports.setHumidity = setHumidity;
function addPressure(delta, airFlowState) {
    return setPressure(uom_1.Amount.plus(airFlowState.pressure, delta), airFlowState);
}
exports.addPressure = addPressure;
function setPressure(newPressure, airFlowState) {
    if (uom_1.Amount.lessThan(airFlowState.temperature, index_1.AmountConversions.getSaturationTemperatureOfWater(newPressure))) {
        var saturated = index_1.AmountConversions.dewPointTemperatureToHumidityRatio(newPressure, uom_1.Amount.create(saturationSafety *
            uom_1.Amount.valueAs(uom_units_1.Units.Kelvin, airFlowState.temperature), uom_units_1.Units.KelvinDewPoint));
        return create(airFlowState.temperature, uom_1.Amount.greaterThan(airFlowState.humidity, saturated)
            ? saturated
            : airFlowState.humidity, newPressure, airFlowState.flow);
    }
    return create(airFlowState.temperature, airFlowState.humidity, newPressure, airFlowState.flow);
}
exports.setPressure = setPressure;
function density(airStateFlow) {
    return index_1.AshraeHb2009.calculateDensityOfMoistAirMixture(airStateFlow.temperature, airStateFlow.pressure, airStateFlow.humidity);
}
exports.density = density;
function wetTemperature(airFlowState) {
    return index_1.AmountConversions.humidityRatioToWetTemperature(airFlowState.pressure, airFlowState.temperature, airFlowState.humidity);
}
exports.wetTemperature = wetTemperature;
function dewPointTemperature(airFlowState) {
    return index_1.AmountConversions.humidityRatioToDewPointTemperature(airFlowState.pressure, airFlowState.humidity);
}
exports.dewPointTemperature = dewPointTemperature;
function specificEnthalpy(airFlowState) {
    return index_1.AmountConversions.humidityRatioToSpecificEnthalpy(airFlowState.pressure, airFlowState.temperature, airFlowState.humidity);
}
exports.specificEnthalpy = specificEnthalpy;
